import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type OpenPresetManagerMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type OpenPresetManagerMutation = { __typename?: 'Mutation', openPresetManager?: boolean | null };


export const OpenPresetManager = /*#__PURE__*/ gql`
    mutation OpenPresetManager {
  openPresetManager
}
    ` as unknown as DocumentNode<OpenPresetManagerMutation, OpenPresetManagerMutationVariables>;

          

          export const useOpenPresetManagerMutation = (options?:MutationHookOptions<OpenPresetManagerMutation, OpenPresetManagerMutationVariables>) => useMutation(OpenPresetManager, options);
          

          export type OpenPresetManagerMutationOptions = MutationHookOptions<OpenPresetManagerMutation, OpenPresetManagerMutationVariables>;

          

          export type OpenPresetManagerMutationResult = ReturnType<typeof useOpenPresetManagerMutation>[1];

          
